/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type UseServiceBreakLocationsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type UseServiceBreakLocationsQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
      type: Types.ServiceBreakLocationType
      polygon: string | null
      routableLocation: {
        __typename?: 'LocationWithHeading'
        latitude: number
        longitude: number
        heading: number
      } | null
    }>
  }
}

export const UseServiceBreakLocationsDocument = gql`
    query useServiceBreakLocations($regionId: ID!) {
  serviceBreakLocations(input: {regionId: $regionId}) {
    serviceBreakLocations {
      id
      name
      type
      polygon
      routableLocation {
        latitude
        longitude
        heading
      }
    }
  }
}
    `

/**
 * __useUseServiceBreakLocationsQuery__
 *
 * To run a query within a React component, call `useUseServiceBreakLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseServiceBreakLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseServiceBreakLocationsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useUseServiceBreakLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UseServiceBreakLocationsQuery,
    UseServiceBreakLocationsQueryVariables
  > &
    (
      | { variables: UseServiceBreakLocationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UseServiceBreakLocationsQuery,
    UseServiceBreakLocationsQueryVariables
  >(UseServiceBreakLocationsDocument, options)
}
export function useUseServiceBreakLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UseServiceBreakLocationsQuery,
    UseServiceBreakLocationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UseServiceBreakLocationsQuery,
    UseServiceBreakLocationsQueryVariables
  >(UseServiceBreakLocationsDocument, options)
}
// @ts-ignore
export function useUseServiceBreakLocationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UseServiceBreakLocationsQuery,
    UseServiceBreakLocationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UseServiceBreakLocationsQuery,
  UseServiceBreakLocationsQueryVariables
>
export function useUseServiceBreakLocationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UseServiceBreakLocationsQuery,
        UseServiceBreakLocationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UseServiceBreakLocationsQuery | undefined,
  UseServiceBreakLocationsQueryVariables
>
export function useUseServiceBreakLocationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UseServiceBreakLocationsQuery,
        UseServiceBreakLocationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UseServiceBreakLocationsQuery,
    UseServiceBreakLocationsQueryVariables
  >(UseServiceBreakLocationsDocument, options)
}
export type UseServiceBreakLocationsQueryHookResult = ReturnType<
  typeof useUseServiceBreakLocationsQuery
>
export type UseServiceBreakLocationsLazyQueryHookResult = ReturnType<
  typeof useUseServiceBreakLocationsLazyQuery
>
export type UseServiceBreakLocationsSuspenseQueryHookResult = ReturnType<
  typeof useUseServiceBreakLocationsSuspenseQuery
>
export type UseServiceBreakLocationsQueryResult = Apollo.QueryResult<
  UseServiceBreakLocationsQuery,
  UseServiceBreakLocationsQueryVariables
>
